import {
  LucideContainer,
  LucideFileOutput,
  LucideLayoutDashboard,
  LucideShip,
  LucideWalletCards,
} from 'lucide-react';

import { CustomerPortalLayout } from './_components/_layouts/CustomerPortalLayout';
import { BillListView } from './_components/bills/_BillListView';
import { BookingDetailsView } from './_components/bookings/_BookingDetailsView';
import { BookingsListView } from './_components/bookings/_BookingsListView';
import { LoadDetailsView } from './_components/loads/_LoadDetailsView';
import { LoadListView } from './_components/loads/_LoadListView';
import { PurchaseOrderDetailsView } from './_components/purchase-orders/_PurchaseOrderDetailsView';
import { PurchaseOrderListView } from './_components/purchase-orders/_PurchaseOrderListView';
import { CounterpartySalesOrderDialog } from './_components/purchase-orders/CounterpartySalesOrderDialog';
import { customerPortalRoutes } from './routes';

import { createAppModule } from '~/shared/routing/createAppModule';
import { createModuleNav } from '~/shared/routing/createModuleNav';
import { createModuleRoutes } from '~/shared/routing/createModuleRoutes';

const routeDefs = createModuleRoutes({
  root: {
    path: customerPortalRoutes.root,
    label: (t) => t.menu.customerPortal.root,
    icon: LucideLayoutDashboard,
  },
  purchaseOrders: {
    path: customerPortalRoutes.purchaseOrders,
    label: (t) => t.menu.customerPortal.purchaseOrders,
    icon: LucideFileOutput,
    component: PurchaseOrderListView,
  },
  purchaseOrderDetails: {
    path: customerPortalRoutes.purchaseOrderDetails,
    component: PurchaseOrderDetailsView,
  },
  purchaseOrderCounterpartySO: {
    path: customerPortalRoutes.purchaseOrderCounterpartySO,
    component: CounterpartySalesOrderDialog,
  },
  bookings: {
    path: customerPortalRoutes.bookings,
    label: (t) => t.menu.customerPortal.bookings,
    icon: LucideShip,
    component: BookingsListView,
  },
  bookingDetails: {
    path: customerPortalRoutes.bookingDetails,
    component: BookingDetailsView,
  },
  loads: {
    path: customerPortalRoutes.loads,
    label: (t) => t.menu.customerPortal.loads,
    icon: LucideContainer,
    component: LoadListView,
  },
  loadDetails: {
    path: customerPortalRoutes.loadDetails,
    component: LoadDetailsView,
  },
  bills: {
    path: customerPortalRoutes.bills,
    label: (t) => t.menu.customerPortal.bills,
    icon: LucideWalletCards,
    component: BillListView,
  },
});

// prettier-ignore
const customerPortalNav = createModuleNav(($) =>
  $(routeDefs.root, [
    $(routeDefs.purchaseOrders),
    $(routeDefs.purchaseOrderDetails, [
      $(routeDefs.purchaseOrderCounterpartySO),
    ]),
    $(routeDefs.bookings),
    $(routeDefs.bookingDetails),
    $(routeDefs.loads),
    $(routeDefs.loadDetails),
    $(routeDefs.bills),
  ]),
);

export const customerPortalModule = createAppModule({
  routes: routeDefs,
  nav: customerPortalNav,
  layout: CustomerPortalLayout,
  requiredEntitlement: 'customerPortal',
  isExclusive: true,
});
